// Vendored from @tiptap/extension-table-header@2.0.3.
import {mergeAttributes, Node} from '@tiptap/core'

export interface TableHeaderOptions {
  HTMLAttributes: Record<string, any>
}

export const TableHeader = Node.create<TableHeaderOptions>({
  name: 'tableHeader',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  content: 'block+',

  addAttributes() {
    return {
      // Reference to the TableColumn block this cell belongs to.
      columnId: {
        default: null,
        keepOnSplit: true,
        parseHTML: (element) => element.getAttribute('data-column-id'),
        renderHTML: (attributes) => {
          if (!attributes.columnId) return {}
          return {'data-column-id': attributes.columnId}
        },
      },
      colspan: {
        default: 1,
      },
      rowspan: {
        default: 1,
      },
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute('colwidth')
          const value = colwidth ? [parseInt(colwidth, 10)] : null

          return value
        },
      },
    }
  },

  tableRole: 'header_cell',

  isolating: true,

  parseHTML() {
    return [{tag: 'th'}]
  },

  renderHTML({HTMLAttributes}) {
    return ['th', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },
})
